export enum WIDGET_STREAM {
    /**
     * @value %USER% attends an event.
     * @description Text in a Feed that explains an user is attending an event
     */
    USER_ATTENDS_AN_EVENT = 'WIDGET_STREAM.USER_ATTENDS_AN_EVENT',
    /**
     * @value %USER% commented an article.
     * @description Text in a Feed that explains an user has commented on an article
     */
    USER_COMMENTED_AN_ARTICLE = 'WIDGET_STREAM.USER_COMMENTED_AN_ARTICLE',
    /**
     * @value %USER% commented an event.
     * @description Text in a Feed that explains an user has commented on an event
     */
    USER_COMMENTED_AN_EVENT = 'WIDGET_STREAM.USER_COMMENTED_AN_EVENT',
    /**
     * @value %USER% commented a post.
     * @description Text in a Feed that explains an user has commented a post in a community
     */
    USER_COMMENTED_A_POST = 'WIDGET_STREAM.USER_COMMENTED_A_POST',
    /**
     * @value %USER% commented in %CONTENT%.
     * @description Text in a Feed that explains an user has commented in a piece of content
     */
    USER_COMMENTED_IN_CONTENT = 'WIDGET_STREAM.USER_COMMENTED_IN_CONTENT',
    /**
     * @value You are enrolled in a training course
     */
    USER_ENROLLED_IN_A_TRAINING = 'WIDGET_STREAM.USER_ENROLLED_IN_A_TRAINING',
    /**
     * @value %USER% started following a community.
     * @description Text in a Feed that explains an user started following a community
     */
    USER_STARTED_FOLLOWING_A_COMMUNITY = 'WIDGET_STREAM.USER_STARTED_FOLLOWING_A_COMMUNITY',
}
